import AboutUsHeroSection from "./AboutUsHeroSection/AboutUsHeroSection";
import AboutUsInfoSection from "./AboutUsInfoSection/AboutUsInfoSection";
import WhyHirestarSection from "../HomePage/WhyHirestarSection/WhyHirestarSection";
import TestimonialComponent from "../../Components/Testimonial/TestimonialComponent";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import { Helmet } from "react-helmet";

const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://hirestar.io/#organization",
      name: "HireStar.io",
      url: "https://hirestar.io",
      logo: {
        "@type": "ImageObject",
        url: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
      },
      description:
        "HireStar.io is a background verification company powered by blockchain, offering secure and efficient background checks to streamline hiring processes.",
      founder: {
        "@type": "Person",
        name: "Praful Vinayak Bahadure",
      },
      foundingDate: "2018",
      foundingLocation: {
        "@type": "Place",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Hyderabad",
          addressRegion: "Telangana",
          addressCountry: "India",
        },
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "20 Inorbit Mall Road, THUB",
        addressLocality: "Hyderabad",
        addressRegion: "Telangana",
        postalCode: "500081",
        addressCountry: "IN",
      },
      sameAs: [
        "https://in.linkedin.com/showcase/hirestar.io/",
        "https://www.facebook.com/hirestario",
        "https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09",
        "https://www.instagram.com/hirestar.io/",
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://hirestar.io/about-us",
      url: "https://hirestar.io/about-us",
      name: "About Us – HireStar.io",
      description:
        "Learn about HireStar.io, a blockchain-powered background verification company committed to enhancing hiring processes with secure and efficient solutions.",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "About Us",
          item: "https://hirestar.io/about-us",
        },
      ],
    },
  ],
};

const AboutUsPage = () => {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>About Us | Hirestar.io</title>
        <title>
          About Us - Hirestar.io | India's Blockchain Powered Background
          Verification Company
        </title>
        <meta
          name="description"
          content="About Hirestar.io: We offers blockchain and AI-driven identity verification solutions to help
           businesses establish a secure workforce and verified customer base, reducing fraud risks."
        />
        <meta
          name="keywords"
          content="Hirestar.io, identity verification, background screening, digital onboarding, AI-driven solutions, India's leading verification company, about Hirestar.io, Hiring with blockchain technology"
        />

        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />

        <meta
          property="og:title"
          content="About Us - Hirestar.io | India's Blockchain Based Background Verification Company"
        />
        <meta
          property="og:description"
          content="About Hirestar.io: We offers blockchain and AI-driven identity verification solutions to help
           businesses establish a secure workforce and verified customer base, reducing fraud risks."
        />
        <meta property="og:url" content="https://hirestar.io/about-us" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/About_Us_img/about_girl.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta name="robots" content="index, follow" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Us - Hirestar.io | India's Blockchain Based Background Verification Company"
        />
        <meta
          name="twitter:description"
          content="About Hirestar.io: We offers blockchain and AI-driven identity verification solutions to help
           businesses establish a secure workforce and verified customer base, reducing fraud risks."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/About_Us_img/about_girl.png"
        />
      </Helmet>
      <div className="section_spacing">
        <AboutUsHeroSection />
      </div>
      <div className="section_spacing">
        <AboutUsInfoSection />
      </div>
      <div>
        <WhyHirestarSection />
      </div>
      <div className="section_spacing">
        <TestimonialComponent />
      </div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
};

export default AboutUsPage;
